import {
  MyReferenceField,
  MyReferenceInput,
} from "../../ra-lb-tools/components/myReference";

export const PacketTypeInput = (props) => {
  return <MyReferenceInput reference="packet-types" {...props} />;
};

export const PacketTypeField = (props) => {
  return <MyReferenceField reference="packet-types" {...props} />;
};
